import axios from 'axios'

const HTTP = axios.create({
  baseURL: process.env.NODE_ENV === "production" ? '/api/' : 'http://localhost:8181/api/',
  timeout: 120000,
})

if (localStorage.getItem("user-token")) {
  HTTP.defaults.headers.common['Authorization'] = `Bearer: ${localStorage.getItem("user-token")}`
} else {
  HTTP.defaults.headers.common['Authorization'] = ''
}

export default HTTP